/* ============================================
   QUOTE WORKSTATION — Totals
   Asset: workstation-totals.js

   recalcTotals(), renderDealSummary().
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;

  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var fmt = Q.fmt;
  var escHtml = Q.escHtml;
  var isAdmin = Q.isAdmin;
  var repEarnsCommission = Q.repEarnsCommission !== false;
  var COMMISSION_GRID = Q.COMMISSION_GRID;
  var COMMISSION_BANDS = Q.COMMISSION_BANDS;

  var dealSummarySection = wrap.querySelector('.rq-ws-deal-summary');

  /* CUSTOM_OFFLINETAXROW_BY_CLAUDE - the tax Shopify calculated at the last save, as the deal owes it now; null when none applies.
     Mirrors offlineTaxParts / offlineTaxOwed in the worker's lib/offline-tax.js: only while the rep's tax is Pending. */
  function offlineTaxShown() {
    var ot = state.offlineTax;
    if (state.tax.mode !== 'pending' || !ot || ot.amount == null) return null;
    var total = Math.round(Number(ot.amount) * 100) / 100;
    if (!(total > 0)) return null;
    var fee = Math.min(Math.max(Math.round((Number(ot.cardFeeTax) || 0) * 100) / 100, 0), total);
    return Math.round(((total - fee) + (state.cardFee.status === 'yes' ? fee : 0)) * 100) / 100;
  }

  function recalcTotals() {
    if (!dom.totalsPanel) return;

    var msrpTotal = 0, directTotal = 0, costTotal = 0;

    state.items.forEach(function(item) {
      var qty = item.quantity || 0;
      // msrp === -1 is the "N/A" sentinel — don't fall back to mapPrice for these,
      // they're items the rep explicitly flagged as having no MSRP (e.g., labor).
      var msrpForList = (item.msrp === -1) ? 0 : (item.msrp || item.mapPrice || 0);
      if (item.isFree) {
        msrpTotal += Math.round(msrpForList * qty * 100) / 100;
      } else {
        msrpTotal += Math.round(msrpForList * qty * 100) / 100;
        directTotal += Math.round((item.directPrice || 0) * qty * 100) / 100;
      }
      costTotal += Math.round((item.cost || 0) * qty * 100) / 100;
    });

    var discountAmount = msrpTotal - directTotal;

    var shippingAmt = 0, installAmt = 0;
    state.fees.forEach(function(f) {
      if (f.title === 'Shipping & Freight') {
        shippingAmt = f.status === 'value' ? (f.amount || 0) : 0;
      } else if (f.title === 'Installation') {
        installAmt = f.status === 'value' ? (f.amount || 0) : 0;
      }
    });

    var customFeesTotal = 0;
    state.customFees.forEach(function(f) {
      if (f.autoPercent) {
        f.amount = Math.round(directTotal * f.autoPercent / 100 * 100) / 100;
      }
      customFeesTotal += f.amount || 0;
    });

    if (state.tax.mode === 'auto') {
      state.tax.rate = Q.getAutoTaxRate ? Q.getAutoTaxRate() : 0;
    }
    if (state.tax.mode !== 'none' && state.tax.rate > 0) {
      var taxableBase = directTotal;
      if (state.tax.includeFreight) taxableBase += shippingAmt;
      if (state.tax.includeInstallation) taxableBase += installAmt;
      state.tax.amount = taxableBase * state.tax.rate / 100;
    } else if (state.tax.mode === 'none' || state.tax.mode === 'pending') {
      state.tax.amount = 0;
    }
    var taxAmt = state.tax.amount || 0;
    /* CUSTOM_OFFLINETAXROW_BY_CLAUDE (Ryan 2026-10-30, Neo's KAREN 51cbd070eaac) - an offline deal to a permit state with the tax left
       Pending: the save asks Shopify for the tax and returns it (state.offlineTax), and the quote PDF, invoice and deal total already
       carry it. The screen shows the same figure, as the worker's offlineTaxOwed does: the goods' tax, plus the card fee's own tax
       once the card fee is charged. Never written to state.tax, so the save payload still says Pending. */
    var offlineTaxAmt = offlineTaxShown();
    if (offlineTaxAmt != null) taxAmt = offlineTaxAmt;

    var cardFeeAmt = state.cardFee.status === 'yes' ? (state.cardFee.amount || 0) : 0;

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Existing Credit (admin-applied deposit
       on linked order). Subtracted from grand total so the printed PDF +
       payment link reflect the balance the customer still owes. */
    var existingCreditAmt = (state.existingCredit && (parseFloat(state.existingCredit.amount) || 0) > 0)
      ? Math.round((parseFloat(state.existingCredit.amount) || 0) * 100) / 100
      : 0;

    var grandTotal = directTotal + shippingAmt + installAmt + customFeesTotal + taxAmt + cardFeeAmt - existingCreditAmt;

    dom.totalsPanel.style.display = (state.items.length > 0 || grandTotal > 0) ? '' : 'none';

    var margin = directTotal > 0 ? ((directTotal - costTotal) / directTotal * 100) : 0;

    if (dom.totals.msrp) dom.totals.msrp.textContent = fmt(msrpTotal);
    if (dom.totals.discount) {
      dom.totals.discount.textContent = '-' + fmt(discountAmount);
      dom.totals.discount.closest('.rq-ws-totals__row').style.display = discountAmount > 0 ? '' : 'none';
    }
    if (dom.totals.direct) dom.totals.direct.textContent = fmt(directTotal);

    var shipFee = state.fees[0];
    if (dom.totals.shipping) {
      if (shipFee.status === 'pending') dom.totals.shipping.textContent = 'Pending';
      else if (shipFee.status === 'free') dom.totals.shipping.textContent = 'FREE';
      /* CUSTOM_WILLCALL_BY_CLAUDE (Ryan 2026-09-17) — the words the customer reads on the quote,
         so the rep sees them here rather than a number that is not being charged. */
      else if (shipFee.status === 'pickup') dom.totals.shipping.textContent = 'Will Call';
      else if (shipFee.status === 'none') dom.totals.shipping.textContent = 'None';
      else dom.totals.shipping.textContent = fmt(shippingAmt);
    }

    var instFee = state.fees[1];
    if (dom.totals.installation) {
      if (instFee.status === 'pending') dom.totals.installation.textContent = 'Pending';
      else if (instFee.status === 'free') dom.totals.installation.textContent = 'FREE';
      else if (instFee.status === 'none') dom.totals.installation.textContent = 'None';
      else dom.totals.installation.textContent = fmt(installAmt);
    }

    if (dom.totals.tax) {
      dom.totals.tax.textContent = offlineTaxAmt != null ? fmt(taxAmt) : state.tax.mode === 'none' ? 'Exempt' : state.tax.mode === 'pending' ? (state.taxPlan && state.taxPlan.why === 'no-permit-in-state' ? 'None' : 'On save') : fmt(taxAmt); // CUSTOM_AUTOTAX_BY_CLAUDE - Auto / Exempt; a no-tax state reads "None", as the PDF (Ryan 2026-10-30)
      dom.totals.tax.title = offlineTaxAmt != null ? 'Sales tax Shopify calculated for ' + (state.offlineTax.state || 'this state') + ' at the last save' : ''; // CUSTOM_OFFLINETAXROW_BY_CLAUDE
      /* CUSTOM_AUTOTAX_BY_CLAUDE (Ryan 2026-10-30: "not super obvious to the rep that anything was added") - the row names the rate and
         the state, and reads in full weight, once Shopify's tax is on the quote. */
      var taxLabel = dom.totals.tax.previousElementSibling;
      if (taxLabel) {
        var ot = state.offlineTax;
        var pct = ot && ot.rate != null ? Math.round(Number(ot.rate) * 100000) / 1000 : null;
        taxLabel.textContent = offlineTaxAmt != null
          ? '+ Tax (' + (pct != null ? (pct.toFixed(3).slice(-1) === '0' ? pct.toFixed(2) : pct.toFixed(3)) + '% ' : '') /* CUSTOM_TAXRATEFMT_BY_CLAUDE - 2 to 3 decimals */ + (ot.state || '') + ')'
          : state.tax.mode === 'none' ? '+ Tax (exempt)' : '+ Tax';
        taxLabel.parentNode.style.fontWeight = offlineTaxAmt != null ? '700' : '';
      }
    }
    if (Q.updateTaxUI) Q.updateTaxUI();

    var cfRows = wrap.querySelector('.rq-ws-totals__custom-fees-rows');
    if (cfRows) {
      var cfHtml = '';
      state.customFees.forEach(function(f, fi) {
        var label = f.title || 'Custom Fee';
        cfHtml += '<div class="rq-ws-totals__row rq-ws-totals__row--fee"><span>+ ' + escHtml(label) + '</span><span>' + fmt(f.amount || 0) + '</span></div>';
        if (f.autoPercent) {
          var amtInput = dom.feesCustomRows.querySelector('[data-custom-fee-idx="' + fi + '"][data-custom-fee-field="amount"]');
          if (amtInput) amtInput.value = fmt(f.amount);
        }
      });
      cfRows.innerHTML = cfHtml;
    }
    var cfCardRow = wrap.querySelector('.rq-ws-totals__card-fee-row');
    if (cfCardRow) {
      cfCardRow.innerHTML = '<span>+ Card Fee (2.9%)</span><span>' + fmt(cardFeeAmt) + '</span>';
      cfCardRow.style.display = cardFeeAmt > 0 ? '' : 'none';
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Existing Credit row. Shown when admin
       has entered a credit amount. sourceRef appended in parens when set. */
    var ecRow = wrap.querySelector('.rq-ws-totals__existing-credit-row');
    if (ecRow) {
      if (existingCreditAmt > 0) {
        var ecRef = (state.existingCredit && state.existingCredit.sourceRef) ? state.existingCredit.sourceRef : '';
        var ecLabel = '− Existing Credit' + (ecRef ? ' <span style="color:var(--rq-text-muted);font-weight:400;">(' + escHtml(ecRef) + ')</span>' : '');
        ecRow.innerHTML = '<span>' + ecLabel + '</span><span>-' + fmt(existingCreditAmt) + '</span>';
        ecRow.style.display = '';
      } else {
        ecRow.style.display = 'none';
      }
    }
    if (dom.totals.grand) dom.totals.grand.textContent = fmt(grandTotal);
    if (dom.totals.margin) dom.totals.margin.textContent = margin.toFixed(1) + '%';

    state.lastGrandTotal = Math.round(grandTotal * 100);

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Deal Summary uses the PRE-credit grand
       total. Reason: the existing credit represents money already on the
       books somewhere — a deposit paid on a linked parent quote, or a
       customer credit/refund earned from a prior order. Subtracting it
       from THIS quote's GP would double-count (revenue was already
       captured wherever the credit originated). Total Gross Profit
       should reflect the full value of the goods being sold on this
       quote; the credit + balance-due line below it shows how the
       payment is split. */
    var dealSummaryGrandTotal = grandTotal + existingCreditAmt;
    renderDealSummary(msrpTotal, directTotal, costTotal, shippingAmt, installAmt, customFeesTotal, taxAmt, cardFeeAmt, dealSummaryGrandTotal, discountAmount, existingCreditAmt, grandTotal);

    state.dirty = true;

    var freightPanel = Q.freightPanel;
    if (isAdmin && freightPanel && freightPanel.querySelector('.rq-ws-freight-panel__body--open')) {
      if (Q.renderFreightVendors) Q.renderFreightVendors();
    }
    if (Q.checkFreightStaleness) Q.checkFreightStaleness();
    if (Q.updateSaveButton) Q.updateSaveButton();
    if (Q.updateRequestButton) Q.updateRequestButton();
  }

  function renderDealSummary(msrpTotal, directTotal, costTotal, shippingAmt, installAmt, customFeesTotal, taxAmt, cardFeeAmt, grandTotal, discountAmount, existingCreditAmt, balanceDueTotal) {
    if (!dealSummarySection) return;
    var hasItems = state.items.length > 0;
    dealSummarySection.style.display = hasItems ? '' : 'none';
    if (!hasItems) return;

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — the two halves of Fees & Extras, computed
       ONCE for the whole panel. The P&L block and the commission block below both need them, and
       the commission block sits OUTSIDE the `if (pnlBody)` guard — deriving it twice is how two
       parts of one panel come to disagree about the same deal. Split per ROW, never on the net. */
    var feeCharges = 0, feeDiscounts = 0;
    state.customFees.forEach(function (f) {
      var a = (f && f.amount) || 0;
      if (a < 0) feeDiscounts += a; else feeCharges += a;
    });
    feeDiscounts = Math.round(feeDiscounts * 100) / 100;
    feeCharges = Math.round(feeCharges * 100) / 100;

    var R = '<div class="rq-ws-deal-panel__row">';
    var RB = '<div class="rq-ws-deal-panel__row rq-ws-deal-panel__row--bold">';
    var RG = '<div class="rq-ws-deal-panel__row rq-ws-deal-panel__row--grand">';
    var RH = '<div class="rq-ws-deal-panel__row rq-ws-deal-panel__row--header">';
    var DIV = '<div class="rq-ws-deal-panel__divider"></div>';
    var E = '</div>';

    var pnlBody = wrap.querySelector('.rq-ws-deal-panel--pnl .rq-ws-deal-panel__body');
    if (pnlBody) {
      var showAddOns = wrap.querySelector('.rq-ws-pnl-addons-toggle');
      var addOnsOn = showAddOns ? showAddOns.checked : false;

      var freightAsCosted = state.freight.totalCost || 0;
      var installAsCosted = state.installation.totalCost || 0;
      var shippingCostLine = addOnsOn ? freightAsCosted : shippingAmt;
      var installCostLine = addOnsOn ? installAsCosted : installAmt;
      /* Both blocks below need the split, and the commission block is outside this `if`. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — A DISCOUNT IS NOT A COST.

         Ryan: *"I added a -$100 discount… in the Deal Summary section I don't see any difference
         in the P&L breakdown, OR in the commission breakdown section which should be affected by
         the P&L."* He was right twice over, and the second reason is why it was invisible rather
         than merely wrong.

         ⛔ CUSTOM FEES SAT ON BOTH SIDES AT ONCE. `customFeesTotal` is inside `grandTotal` as
         revenue and was inside `otherCosts` as a cost, so in `totalGP = grandTotal − totalCOGS`
         the two cancelled EXACTLY. Every custom fee — charge or discount — moved Total GP by zero.
         Splitting the rows leaves the pass-through charges cancelling as before while the discount
         survives on the revenue side only, which is what a discount is: money we chose not to
         collect, with nothing offsetting it.

         ⛔ AND THE ROW WAS HIDDEN BY ITS OWN GUARD. `if (otherCosts > 0)` — with a lone −$100 fee
         `otherCosts` was −100, so the one line that would have shown the rep something happened
         never rendered. That is why the panel looked completely unchanged rather than subtly off.
         Across 200 live deals the custom-fee box holds five rows and every one is negative, so
         this guard has never once been true in production. */
      var otherCosts = cardFeeAmt + feeCharges;

      var totalCOGS = costTotal + taxAmt + shippingCostLine + installCostLine + otherCosts;

      /* Revenue actually collected on goods — the base for both the figure and its margin. */
      var goodsRevenue = directTotal + feeDiscounts;
      var gpGoods = goodsRevenue - costTotal;
      var gpGoodsMargin = goodsRevenue > 0 ? (gpGoods / goodsRevenue * 100) : 0;

      var totalGP = grandTotal - totalCOGS;
      var totalGPMargin = grandTotal > 0 ? (totalGP / grandTotal * 100) : 0;

      var gpGoodsColor = gpGoods >= 0 ? 'var(--rq-success)' : 'var(--rq-error)';
      var totalGPColor = totalGP >= 0 ? 'var(--rq-success)' : 'var(--rq-error)';

      var pl = '';
      pl += RH + '<span>COSTS</span><span></span>' + E;
      pl += R + '<span>Equipment Cost</span><span>' + fmt(costTotal) + '</span>' + E;
      pl += R + '<span>Tax</span><span>' + fmt(taxAmt) + '</span>' + E;
      pl += R + '<span>Shipping' + (addOnsOn ? ' (actual)' : '') + '</span><span>' + fmt(shippingCostLine) + '</span>' + E;
      pl += R + '<span>Installation' + (addOnsOn ? ' (actual)' : '') + '</span><span>' + fmt(installCostLine) + '</span>' + E;
      if (otherCosts > 0) pl += R + '<span>Other</span><span>' + fmt(otherCosts) + '</span>' + E;
      pl += RB + '<span>Total COGS</span><span>' + fmt(totalCOGS) + '</span>' + E;

      pl += DIV;
      /* The discount gets its own line above GP of Goods, on the REVENUE side of the divider, so
         the panel reads as the arithmetic it now is: goods revenue came down, costs did not. */
      if (feeDiscounts < 0) {
        pl += R + '<span>Discounts</span><span style="color:var(--rq-error);">' + fmt(feeDiscounts) + '</span>' + E;
      }
      pl += RB + '<span>GP of Goods</span><span style="color:' + gpGoodsColor + ';">' + fmt(gpGoods) + ' (' + gpGoodsMargin.toFixed(1) + '%)</span>' + E;

      if (isAdmin) {
        var freightMarkup = shippingAmt - freightAsCosted;
        var installMarkup = installAmt - installAsCosted;
        var hasMarkups = freightMarkup !== 0 || installMarkup !== 0;
        pl += '<div class="rq-ws-pnl-addons' + (addOnsOn && hasMarkups ? ' rq-ws-pnl-addons--open' : '') + '">';
        if (hasMarkups) {
          pl += DIV;
          pl += RH + '<span>ADD-ON MARGINS</span><span></span>' + E;
          if (freightMarkup !== 0) pl += R + '<span>Freight Markup</span><span style="color:' + (freightMarkup >= 0 ? 'var(--rq-success)' : 'var(--rq-error)') + ';">' + fmt(freightMarkup) + '</span>' + E;
          if (installMarkup !== 0) pl += R + '<span>Install Markup</span><span style="color:' + (installMarkup >= 0 ? 'var(--rq-success)' : 'var(--rq-error)') + ';">' + fmt(installMarkup) + '</span>' + E;
        }
        pl += '</div>';
      }

      pl += DIV;
      pl += RG + '<span>Total Gross Profit</span><span style="color:' + totalGPColor + ';">' + fmt(totalGP) + ' (' + totalGPMargin.toFixed(1) + '%)</span>' + E;

      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Footer rows for admin-applied
         Existing Credit. Total GP above is computed on the pre-credit
         grand total (deal's true value); these rows break out how the
         payment splits between the credit (already paid elsewhere) and
         the balance the customer will pay on this quote's payment link. */
      if (existingCreditAmt > 0) {
        var ecRef = (state.existingCredit && state.existingCredit.sourceRef) ? state.existingCredit.sourceRef : '';
        var ecLabel = 'Existing Credit Applied' + (ecRef ? ' <span style="color:var(--rq-text-muted);font-weight:400;">(' + escHtml(ecRef) + ')</span>' : '');
        pl += DIV;
        pl += R + '<span>' + ecLabel + '</span><span>-' + fmt(existingCreditAmt) + '</span>' + E;
        pl += RB + '<span>Customer Balance Due</span><span>' + fmt(balanceDueTotal || 0) + '</span>' + E;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      if (isAdmin) {
        var checked = addOnsOn ? ' checked' : '';
        pl += '<label class="rq-ws-deal-panel__addon-toggle"><input type="checkbox" class="rq-ws-pnl-addons-toggle"' + checked + '> Show add-on margins</label>';
      }

      pnlBody.innerHTML = pl;

      var newToggle = pnlBody.querySelector('.rq-ws-pnl-addons-toggle');
      if (newToggle) {
        newToggle.addEventListener('change', function() {
          var addonsWrap = pnlBody.querySelector('.rq-ws-pnl-addons');
          if (this.checked) {
            recalcTotals();
            var fresh = pnlBody.querySelector('.rq-ws-pnl-addons');
            if (fresh && fresh.classList.contains('rq-ws-pnl-addons--open')) {
              fresh.style.maxHeight = '0';
              fresh.offsetHeight;
              fresh.style.maxHeight = fresh.scrollHeight + 'px';
              var done1 = false;
              var cleanup1 = function() { if (done1) return; done1 = true; fresh.style.maxHeight = 'none'; fresh.removeEventListener('transitionend', cleanup1); };
              fresh.addEventListener('transitionend', cleanup1);
              setTimeout(cleanup1, 500);
            }
          } else {
            if (addonsWrap) {
              addonsWrap.style.maxHeight = addonsWrap.scrollHeight + 'px';
              addonsWrap.offsetHeight;
              addonsWrap.style.maxHeight = '0';
              addonsWrap.classList.remove('rq-ws-pnl-addons--open');
              var done2 = false;
              var cleanup2 = function() { if (done2) return; done2 = true; addonsWrap.removeEventListener('transitionend', cleanup2); recalcTotals(); };
              addonsWrap.addEventListener('transitionend', cleanup2);
              setTimeout(cleanup2, 500);
            } else {
              recalcTotals();
            }
          }
        });
      }
    }

    var cm = '';
    var ls = state.leadSource;
    var terms = state.send.terms;
    var band = ls ? COMMISSION_GRID[ls] : null;
    var rate = band ? (band[terms] || band['Net 30']) : null;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom "% of GP" entered on the
       Workstation Terms & Options trumps the band-derived rate. When
       state.referral.gpPercent > 0, that value IS the commission rate
       for this order — Band line is hidden, recipient name annotates
       the Commission line.

       Out-of-band guard: if the entered % exceeds the max rate in the
       leadSource's band (e.g. >17% for shared), color the Commission
       Rate red as a warning. NOT a hard block — admin can intentionally
       set a higher rate for special cases; the red is just a flag.
       Lower-than-band is allowed silently (admin paying less is fine). */
    var customGpPct = (state.referral && parseFloat(state.referral.gpPercent)) || 0;
    var recipientName = (state.referral && state.referral.name) ? String(state.referral.name).trim() : '';
    var useCustomRate = customGpPct > 0 && recipientName;
    if (useCustomRate) {
      rate = customGpPct / 100;
    }
    var bandMaxRate = band ? Math.max.apply(null, Object.keys(band).map(function (k) { return band[k]; })) : 0;
    var overBand = useCustomRate && bandMaxRate > 0 && customGpPct > (bandMaxRate * 100);
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    var lsLabels = { outbound: 'Outbound Deal', inbound: 'Inbound Deal', shared: 'Shared Deal' };
    cm += R + '<span>Deal Type</span><span>' + (ls ? lsLabels[ls] || ls : '—') + '</span>' + E;
    cm += R + '<span>Payment Terms</span><span>' + (terms || '—') + '</span>' + E;

    if (ls && (band || useCustomRate)) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — When the rep doesn't earn commission
         (e.g. admin managing quotes), suppress Band + Rate since they're
         meaningless for this quote. The useCustomRate path stays active
         though — that's a referral payout to a named recipient, owed
         regardless of whether the on-quote rep takes a cut. */
      var _suppressRepCommission = !repEarnsCommission && !useCustomRate;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Hide Band when custom rate. */
      if (!useCustomRate && !_suppressRepCommission) {
        cm += R + '<span>Commission Band</span><span>' + (COMMISSION_BANDS[ls] || '—') + '</span>' + E;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Red font when the custom % exceeds
         the band max. Title attribute explains the warning on hover. */
      var rateStyle = overBand
        ? ' style="color:#dc2626;font-weight:700;" title="Above the standard ' + (COMMISSION_BANDS[ls] || '') + ' band for ' + (lsLabels[ls] || ls) + '. Saving allowed — flag only."'
        : '';
      if (!_suppressRepCommission) {
        cm += R + '<span>Commission Rate</span><span' + rateStyle + '>' + (rate * 100).toFixed(1).replace(/\.0$/, '') + '% of GP</span>' + E;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      cm += DIV;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — commission pays on what the deal actually
         earned. A discount is the one number on this quote the rep chose alone, so it belongs in
         their payout base; leaving it out pays the rep, the CFA and any referral on revenue nobody
         collected. Mirrors `gpOfGoods` in the worker (lib/wm-financials-normalize.js), which is
         what the Deal Dashboard's own Commission card reads — the two must not disagree. */
      var gpForComm = directTotal + feeDiscounts - costTotal;
      var commAmt = Math.round(gpForComm * rate * 100) / 100;

      cm += RB + '<span>GP of Goods</span><span style="color:var(--rq-success);">' + fmt(gpForComm) + '</span>' + E;
      cm += DIV;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom-rate path annotates Commission
         line with recipient name. Non-earning rep on a non-referral quote
         shows "—" + muted "n/a" hint so the Paid Ads contribution-margin
         calc doesn't pick up a phantom commission cost. */
      var _commLabel = useCustomRate ? ('Commission (' + escHtml(recipientName) + ')') : 'Commission';
      if (_suppressRepCommission) {
        cm += RG + '<span>' + _commLabel + '</span><span style="color:var(--rq-text-muted);" title="This rep doesn\'t earn commission on quotes — no payout accrues here.">—</span>' + E;
      } else {
        cm += RG + '<span>' + _commLabel + '</span><span style="color:var(--rq-success);">' + fmt(commAmt) + '</span>' + E;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      if (state.cfaAttribution && state.cfaAttribution !== 'none') {
        cm += DIV;
        cm += R + '<span>CFA Rep</span><span>' + escHtml(state.cfaAttribution) + '</span>' + E;
        cm += R + '<span>CFA Rate</span><span>10% of GP</span>' + E;
        var cfaAmt = Math.round(gpForComm * 0.10 * 100) / 100;
        cm += RB + '<span>CFA Commission</span><span style="color:var(--rq-success);">' + fmt(cfaAmt) + '</span>' + E;
      }
    } else {
      cm += DIV;
      cm += '<div class="rq-ws-deal-panel__hint">Set Lead Source and Payment Terms to see commission</div>';
    }

    var commBody = wrap.querySelector('.rq-ws-deal-panel--commission .rq-ws-deal-panel__body');
    if (commBody) commBody.innerHTML = cm;
  }

  Q.recalcTotals = recalcTotals;
  Q.renderDealSummary = renderDealSummary;
})();
